import { createRoot } from 'react-dom/client'
import { installTranslationResilience } from 'translation-resilience'

import { addSentryBreadcrumb, initSentry, setSentryTag } from '@flatsy/utils/Sentry'
import i18n from '@flatsy/utils/translations'

import './index.css'
import './static/assets/fonts/sfpro/font.css'
import Main from './main'

initSentry({
  dsn: 'https://4c15d093d8617b38a511a43fad24ac06@o144097.ingest.us.sentry.io/4511745232273408',
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_VERSION,
})

// Browser page translation (Google Translate…) replaces React's text nodes and
// crashes the app; this restores them instead so translation keeps working.
// Its events repeat on every re-render of translated text, so each distinct
// message is only logged once to avoid flooding Sentry breadcrumbs.
const seenTranslationEvents = new Set<string>()
installTranslationResilience({
  onEvent: (message) => {
    if (message === 'translation activity detected') setSentryTag('page_translated', 'true')
    if (seenTranslationEvents.has(message)) return
    seenTranslationEvents.add(message)
    addSentryBreadcrumb('translation-resilience', message)
  },
})

// Keep <html lang> in sync with the UI language for screen readers and
// spellcheck. Must run after installTranslationResilience, which tells our
// <html lang> writes apart from Firefox's translator ones.
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng.split('-')[0]
})

const root = document.getElementById('root')

if (!root) {
  throw new Error('Root element not found')
}

// TODO: Re-add StrictMode when all components are fixed
createRoot(root).render(<Main />)
